export default __webpack_public_path__ + "static/media/mleczko_pszczele.f77e6329.svg";